//messages.js
export default {
    tank_type_id: "Tank Type",
    tank_types: "Tank Types",
    delete_tank_type: "Delete Tank Type",
    add_tank_type: "Add Tank Type",
    edit_tank_type: "Edit Tank Type",
    image_url: "Image Url",
    tank_type: "Tank Type",
    slug: "Slug",
    formula: "Formula",
    comments: "Comments",
};
